import React, { Component, Fragment } from "react";

import { NavLink } from "react-router-dom";
import axios from "axios";
import * as actionCreators from "../../../Store/actions/index";
import classes from "./SearchOptions.module.css";
import toggeList from "../../../assets/svg/toggeList.svg";
import rightBlackarrow from "../../../assets/svg/rightBlackarrow.svg";
import Hatchback from "../../../assets/svg/Hatchback.svg";
import Sedan from "../../../assets/svg/Sedan.svg";
import MUV from "../../../assets/svg/MUV.svg";
import Crossover from "../../../assets/svg/Crossover.svg";
import Coupe from "../../../assets/svg/Coupe.svg";
import SUV from "../../../assets/svg/SUV.svg";
import Convertible from "../../../assets/svg/Convertible.svg";
import Quadricycle from "../../../assets/svg/Quadricycle.svg";
import AMT from "../../../assets/svg/AMT.svg";
import Manual from "../../../assets/svg/Manual.svg";
import Automatic from "../../../assets/svg/Automatic.svg";
import Petrol from "../../../assets/svg/Petrol.svg";
import HybirdPetrol from "../../../assets/svg/Hybird&Petrol.svg";
import Electric from "../../../assets/svg/Electric.svg";
import Diesel from "../../../assets/svg/Diesel.svg";
import Gas from "../../../assets/svg/Gas.svg";
import Chopper from "../../../assets/svg/Chopper.svg";
import ATV from "../../../assets/svg/ATV.svg";
import Enduro from "../../../assets/svg/Enduro.svg";
import Scooter from "../../../assets/svg/Scooter.svg";
import Sport from "../../../assets/svg/Sport.svg";
import Street from "../../../assets/svg/Street.svg";
import Cross from "../../../assets/svg/Cross.svg";
import Cruiser from "../../../assets/svg/Cruiser.svg";
import SportTourist from "../../../assets/svg/SportTourist.svg";
import Underbone from "../../../assets/svg/Underbone.svg";
import Naked from "../../../assets/svg/Naked.svg";
import Touring from "../../../assets/svg/Touring.svg";
import Boat from "../../../assets/svg/Boat.svg";
import Bus from "../../../assets/svg/Bus.svg";
import Forklift from "../../../assets/svg/Forklift.svg";
import Lorry from "../../../assets/svg/Lorry.svg";
import Taxi from "../../../assets/svg/Taxi.svg";
import Tractor from "../../../assets/svg/Tractor.svg";
import Trailer from "../../../assets/svg/Trailer.svg";
import Van from "../../../assets/svg/Van.svg";
import { connect } from "react-redux";


const ICONS = {
    Hatchback: Hatchback,
    Sedan: Sedan,
    MUV: MUV,
    Crossover: Crossover,
    Coupe: Coupe,
    SUV: SUV,
    Convertible: Convertible,
    Quadricycle: Quadricycle,
    AMT: AMT,
    Manual: Manual,
    Automatic: Automatic,
    HybirdPetrol: HybirdPetrol,
    Electric: Electric,
    Petrol: Petrol,
    Diesel: Diesel,
    Gas: Gas,
    Chopper: Chopper,
    ATV: ATV,
    Enduro: Enduro,
    Scooter: Scooter,
    Sport: Sport,
    Street: Street,
    Cross: Cross,
    Cruiser: Cruiser,
    SportTourist: SportTourist,
    Underbone: Underbone,
    Naked: Naked,
    Touring: Touring,
    Boat: Boat,
    Bus: Bus,
    Forklift: Forklift,
    Lorry: Lorry,
    Taxi: Taxi,
    Tractor: Tractor,
    Trailer: Trailer,
    Van: Van
};


const vehicleTypes = {
    cars: 'cars',
    motors: 'motors',
    commercials: 'commercials',
    accessories: 'accessories',
    parts: 'parts',
    dealers: 'dealers',
    services: 'services',
    rental: 'rental',
}

const CONDITION = {
    all: 'all',
    new: 'new',
    used: 'used',
    recon: 'recon'
};

const BODY_TYPE = {
    Hatchback: 'Hatchback',
    Sedan: 'Sedan',
    MUV: 'MUV',
    Crossover: 'Crossover',
    Coupe: 'Coupe',
    SUV: 'SUV',
    Convertible: 'Convertible',
    Quadricycle: 'Quadricycle',
};

const MOTORS_BODY_TYPE = {
    Chopper: 'Chopper',
    ATV: 'ATV',
    Enduro: 'Enduro',
    Scooter: 'Scooter',
    Sport: 'Sport',
    Street: 'Street',
    Cross: 'Cross',
    Cruiser: 'Cruiser',
    SportTourist: 'SportTourist',
    Underbone: 'Underbone',
    Naked: 'Naked',
    Touring: 'Touring',
};

const COMMERCIALS_BODY_TYPE = {
    Boat: 'Boat',
    Bus: 'Bus',
    Forklift: 'Forklift',
    Lorry: 'Lorry',
    Taxi: 'Taxi',
    Tractor: 'Tractor',
    Trailer: 'Trailer',
    Van: 'Van',
};

const TRANSMISSION = {
    AMT: 'AMT',
    Manual: 'Manual',
    Automatic: 'Automatic'
}

const DREVIEN_WHEEL = {
    All: 'All',
    FourWD: '4WD',
    AWD: 'AWD',
    FWD: 'FWD',
    RWD: 'RWD',
};

const FUEL_TYPE = {
    HybirdPetrol: 'HybirdPetrol',
    Electric: 'Electric',
    Petrol: 'Petrol',
    Diesel: 'Diesel',
};

const MOTORS_FUEL_TYPE = {
    Electric: 'Electric',
    Petrol: 'Petrol',
    Diesel: 'Diesel',
};

const COMMERCIALS_FUEL_TYPE = {
    Petrol: 'Petrol',
    Electric: 'Electric',
    Gas: 'Gas',
    Diesel: 'Diesel',
}

const STATES = ['Kuala Lumpur', 'Johor', 'Kedah', 'Labuan', 'Melaka', 'Negeri', 'Sembilan', 'Pahang Perak', 'Perlis', 'Pulau Pinang', 'Putrajaya', 'Sabah Sarawak', 'Selangor', 'Terengganu', 'Wilayah Persekutuan'];

class SearchOptions extends Component {
    state = {
        toggelCategories: true,
        vehicleCondition: '',
        bodyType: '',
        transmission: '',
        drivenWheel: '',
        fuelType: '',
        vehicle_make_id: '',
        vehicle_model_id: '',
        vehicle_variant_id: '',
        year_of_manufacture: '',
        minPrice: '',
        maxPrice: '',
        minMilage: '',
        maxMilage: '',
        state: '',
        makes: [],
        models: [],
        filterdModels: [],
        variants: [],
        filtredVariants: [],
        milageValues: [],
        priceValues: [],
    }



    componentDidMount() {
        this.fetchVihecleMakeModelVariant(this.props.vihecleType)
        this.milageGenerators()
    }

    fetchVihecleMakeModelVariant(type) {
        if (type === 'cars' ||
            type === 'motors' ||
            type === 'commercials') {
            axios.get(`${type}/makes`)
                .then(response => {
                    this.setState({
                        makes: response.data.data
                    })
                })
                .catch(error => {
                    console.log(error)
                })
            axios.get(`${type}/models`)
                .then(response => {
                    this.setState({
                        models: response.data.data
                    })
                })
                .catch(error => {
                    console.log(error)
                })
            axios.get(`${type}/variants`)
                .then(response => {
                    this.setState({
                        variants: response.data.data
                    })
                })
                .catch(error => {
                    console.log(error)
                })
        }
    }


    togeelCategories = () => {
        this.setState((prevState) => ({
            toggelCategories: !prevState.toggelCategories
        }))
    }

    inputChangeHandler = (name, value) => {
        this.setState({
            [`${name}`]: value
        })
    }

    selectMakesChangeHandler = (name, value) => {
        let updatedModels = [...this.state.models]
        updatedModels = updatedModels.filter(model => {
            return model.vehicle_make_id === parseInt(value)
        });
        this.setState({
            filterdModels: updatedModels,
            filtredVariants: [],
            [`${name}`]: value
        })
    }

    selectModelsChangedHandler = (name, value) => {
        let updatedVariants = [...this.state.variants]
        updatedVariants = updatedVariants.filter(variant => {
            return variant.vehicle_model_id === parseInt(value)
        })
        this.setState({
            filtredVariants: updatedVariants,
            [`${name}`]: value
        })
    }

    selectVariantsChangedHandler = (name, value) => {
        this.setState({
            [`${name}`]: value
        })
    }

    milageGenerators = () => {
        const milage = [0]
        const price = [2500]
        let milageValue = 0
        let priceValue = 0
        for (let mil = 0; mil < 15; mil++) {
            milageValue = milageValue + 50000
            priceValue = priceValue + 10000
            milage.push(milageValue);
            price.push(priceValue);
        }
        this.setState({
            milageValues: milage,
            priceValues: price,
        })
    }

    restFormHandler = () => {
        this.setState({
            vehicleCondition: '',
            bodyType: '',
            transmission: '',
            drivenWheel: '',
            fuelType: '',
            vehicle_make_id: '',
            vehicle_model_id: '',
            vehicle_variant_id: '',
            year_of_manufacture: '',
            minPrice: '',
            maxPrice: '',
            minMilage: '',
            maxMilage: '',
            state: '',
        })
        //window.location.reload(false)
        this.props.reLoadCompnent()
        this.props.onGetVehicleItems(localStorage.getItem('vehicleType'))
    }

    formSubmitHandler = (event) => {
        event.preventDefault()
        this.searchUrlConstructor(
            this.state.vehicleCondition,
            this.state.bodyType,
            this.state.transmission,
            this.state.drivenWheel,
            this.state.fuelType,
            this.state.vehicle_make_id,
            this.state.vehicle_model_id,
            this.state.vehicle_variant_id,
            this.state.year_of_manufacture,
            this.state.minPrice,
            this.state.maxPrice,
            this.state.minMilage,
            this.state.maxMilage,
            this.state.state,
        )
        window.scrollTo(0, 0)
    }

    searchUrlConstructor = (condition, bodyType, transmission,
        drivenWheel, fuelType, vehicle_make_id,
        vehicle_model_id, vehicle_variant_id, year_of_manufacture,
        minPrice, maxPrice, minMilage, maxMilage, state) => {
        condition = condition === 'all' ? '' : condition;
        drivenWheel = drivenWheel === 'all' ? '' : drivenWheel;
        const vehicleType = this.props.vihecleType
        
        let url = `https://apis-staging.auto.pcari.my/api/v1/${vehicleType}/lists/combined?condition=${condition}&vehicle_make_id=${vehicle_make_id}&vehicle_model_id=${vehicle_model_id}&vehicle_variant_id=${vehicle_variant_id}&year_of_manufacture=${year_of_manufacture}&transmission=${transmission}&body_type=${bodyType}&fuel_type=${fuelType}&driven_wheel=${drivenWheel}&state=${state}`;


        this.props.onGetVehicleItems(vehicleType, url)
        if (condition && bodyType) {
            // console.log(url)
        } else {
            // console.log('NO')
        }
    }

    render() {
        const categoriesBodyClasses = this.state.toggelCategories ?
            `${classes.CategoriesBody}` :
            `${classes.Hide}`;
        const milageVal = this.state.milageValues;
        const priceVal = this.state.priceValues;
        return (
            <div className={classes.SearchOptions}>
                <div className={classes.Categories}>
                    <div className={classes.CategoriesHead}>
                        <h1>Browse by Category</h1>
                        <img src={toggeList} alt='toggel' onClick={this.togeelCategories} />
                    </div>
                    <div className={categoriesBodyClasses}>
                        <ul>
                            {Object.values(vehicleTypes).map(item => {
                                return (
                                    <li key={item}>
                                        <NavLink
                                            to='/Search'
                                            onClick={() => {
                                                this.props.onChangeType(vehicleTypes[`${item}`])
                                                this.fetchVihecleMakeModelVariant(vehicleTypes[`${item}`])
                                            }}
                                            onContextMenu={(event) => {
                                                event.preventDefault()
                                            }}><img src={rightBlackarrow} alt='' style={{ marginRight: '2%' }} />{item}
                                        </NavLink>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>

                {this.props.vihecleType === 'cars' ||
                    this.props.vihecleType === 'all' ||
                    this.props.vihecleType === 'motors' ||
                    this.props.vihecleType === 'commercials' ?
                    <div className={classes.formOptions}>
                        <form onSubmit={event => { this.formSubmitHandler(event) }}>
                            <p>VEHICLE TYPE</p>
                            <div className={classes.VehicleTypes}>
                                {Object.values(CONDITION).map(condition => {
                                    return (
                                        <Fragment key={condition}>
                                            <input value={`${condition}`}
                                                type='radio'
                                                name='vehicleCondition'
                                                id={`${condition}`}
                                                onChange={(event) => {
                                                    this.inputChangeHandler(event.target.name, event.target.value)
                                                }} />
                                            <label htmlFor={`${condition}`} >{condition}</label>
                                        </Fragment>
                                    );
                                })}
                            </div>
                            <p>BODY TYPE</p>
                            <div className={classes.BodyTypes}>
                                {this.props.vihecleType === 'cars' ?
                                    Object.values(BODY_TYPE).map(bodyT => {
                                        return (
                                            <Fragment key={bodyT}>
                                                <input
                                                    value={`${bodyT}`}
                                                    type='radio'
                                                    name='bodyType'
                                                    id={`${bodyT}`}
                                                    onChange={(event) => {
                                                        this.inputChangeHandler(event.target.name, event.target.value)
                                                    }} />
                                                <label className={classes.SmallFont} htmlFor={`${bodyT}`} >
                                                    <img src={ICONS[`${bodyT}`]} alt={`${bodyT}`} style={{ marginBottom: '6px' }} />
                                                    {bodyT}
                                                </label>
                                            </Fragment>

                                        );
                                    })
                                    :
                                    this.props.vihecleType === 'motors' ?
                                        Object.values(MOTORS_BODY_TYPE).map(bodyT => {
                                            return (
                                                <Fragment key={bodyT}>
                                                    <input
                                                        value={`${bodyT}`}
                                                        type='radio'
                                                        name='bodyType'
                                                        id={`${bodyT}`}
                                                        onChange={(event) => {
                                                            this.inputChangeHandler(event.target.name, event.target.value)
                                                        }} />
                                                    <label className={classes.SmallFont} htmlFor={`${bodyT}`} >
                                                        <img src={ICONS[`${bodyT}`]} alt={`${bodyT}`} style={{ marginBottom: '6px' }} />
                                                        {bodyT}
                                                    </label>
                                                </Fragment>

                                            );
                                        })
                                        :
                                        this.props.vihecleType === 'commercials' ?
                                            Object.values(COMMERCIALS_BODY_TYPE).map(bodyT => {
                                                return (
                                                    <Fragment key={bodyT}>
                                                        <input
                                                            value={`${bodyT}`}
                                                            type='radio'
                                                            name='bodyType'
                                                            id={`${bodyT}`}
                                                            onChange={(event) => {
                                                                this.inputChangeHandler(event.target.name, event.target.value)
                                                            }} />
                                                        <label className={classes.SmallFont} htmlFor={`${bodyT}`} >
                                                            <img src={ICONS[`${bodyT}`]} alt={`${bodyT}`} style={{ marginBottom: '6px' }} width='25px' />
                                                            {bodyT}
                                                        </label>
                                                    </Fragment>

                                                );
                                            })
                                            :
                                            null}
                            </div>
                            <p>Transmission</p>
                            <div className={classes.BodyTypes}>
                                {Object.values(TRANSMISSION).map(tran => {
                                    return (
                                        <Fragment key={tran}>
                                            <input
                                                value={tran}
                                                type='radio'
                                                name='transmission'
                                                id={tran}
                                                onChange={event => {

                                                    this.inputChangeHandler(event.target.name, event.target.value)

                                                }}
                                            />
                                            <label htmlFor={tran} >
                                                <img src={ICONS[`${tran}`]} alt={tran} />
                                                {tran}
                                            </label>
                                        </Fragment>
                                    );
                                })}
                            </div>
                            <p>Driven Wheel</p>
                            <div className={classes.DrivenW}>
                                {Object.values(DREVIEN_WHEEL).map(dWheel => {
                                    return (
                                        <Fragment key={dWheel}>
                                            <input
                                                value={dWheel}
                                                type='radio'
                                                name='drivenWheel'
                                                id={dWheel}
                                                onChange={event => {

                                                    this.inputChangeHandler(event.target.name, event.target.value)

                                                }} />
                                            <label htmlFor={dWheel} >{dWheel}</label>
                                        </Fragment>
                                    );
                                })}
                            </div>
                            <p>Fuel Type</p>
                            <div className={classes.BodyTypes}>
                                {this.props.vihecleType === 'cars' ?
                                    Object.values(FUEL_TYPE).map(fuelT => {
                                        return (
                                            <Fragment key={fuelT}>
                                                <input
                                                    value={fuelT}
                                                    type='radio'
                                                    name='fuelType'
                                                    id={fuelT}
                                                    onChange={event => {
                                                        this.inputChangeHandler(event.target.name, event.target.value)
                                                    }}
                                                />
                                                <label htmlFor={fuelT} >
                                                    <img src={ICONS[`${fuelT}`]} alt={fuelT} />
                                                    {fuelT}
                                                </label>
                                            </Fragment>
                                        );
                                    })
                                    :
                                    this.props.vihecleType === 'motors' ?
                                        Object.values(MOTORS_FUEL_TYPE).map(fuelT => {
                                            return (
                                                <Fragment key={fuelT}>
                                                    <input
                                                        value={fuelT}
                                                        type='radio'
                                                        name='fuelType'
                                                        id={fuelT}
                                                        onChange={event => {
                                                            this.inputChangeHandler(event.target.name, event.target.value)
                                                        }}
                                                    />
                                                    <label htmlFor={fuelT} >
                                                        <img src={ICONS[`${fuelT}`]} alt={fuelT} />
                                                        {fuelT}
                                                    </label>
                                                </Fragment>
                                            );
                                        })
                                        :
                                        this.props.vihecleType === 'commercials' ?
                                            Object.values(COMMERCIALS_FUEL_TYPE).map(fuelT => {
                                                return (
                                                    <Fragment key={fuelT}>
                                                        <input
                                                            value={fuelT}
                                                            type='radio'
                                                            name='fuelType'
                                                            id={fuelT}
                                                            onChange={event => {
                                                                this.inputChangeHandler(event.target.name, event.target.value)
                                                            }}
                                                        />
                                                        <label htmlFor={fuelT} >
                                                            <img src={ICONS[`${fuelT}`]} alt={fuelT} />
                                                            {fuelT}
                                                        </label>
                                                    </Fragment>
                                                );
                                            })
                                            :
                                            null
                                }
                            </div>
                            <select
                                name='vehicle_make_id'
                                onChange={event => {
                                    this.selectMakesChangeHandler(event.target.name, event.target.value)
                                }}>
                                <option value=''>Make / Brands </option>
                                {this.state.makes.map(option => {
                                    return (
                                        <option
                                            key={option.id}
                                            value={option.id}>
                                            {option.name}
                                        </option>
                                    );
                                })}
                            </select>
                            <select
                                name='vehicle_model_id'
                                onChange={event => {
                                    this.selectModelsChangedHandler(event.target.name, event.target.value)
                                }}>
                                <option value=''>Models</option>
                                {this.state.filterdModels.map(model => {
                                    return (
                                        <option key={model.id} value={model.id}>{model.name}</option>
                                    );
                                })}

                            </select>
                            <select
                                name='vehicle_variant_id'
                                onChange={event => {
                                    this.selectVariantsChangedHandler(event.target.name, event.target.value)
                                }}>
                                <option value=''>Variants</option>
                                {this.state.filtredVariants.map(variant => {
                                    return (
                                        <option
                                            key={variant.id}
                                            value={variant.id}
                                        >
                                            {variant.name}
                                        </option>
                                    );
                                })}
                            </select>
                            <select >
                                <option value=''>Origin</option>
                                <option value=''>test</option>
                                <option value=''>test</option>
                            </select>
                            <p>Manufacturing Year</p>
                            <input
                                className={classes.textInput}
                                type='number'
                                min='1970'
                                max='2020'
                                placeholder='2019'
                                value={this.state.year_of_manufacture}
                                onChange={event => {
                                    this.setState({
                                        year_of_manufacture: event.target.value
                                    })
                                }}
                            />
                            <p>Mileage</p>
                            <select
                                name='minMilage'
                                onChange={event => {
                                    this.setState({
                                        minMilage: event.target.value
                                    })
                                }}
                            >
                                <option value=''>Mileage (min)</option>
                                {milageVal.map((value, i) => {
                                    return (<option key={i} value={value}>{value} Km</option>)
                                })}
                            </select>
                            <select
                                name='maxMilage'
                                onChange={event => {
                                    this.setState({
                                        maxMilage: event.target.value
                                    })
                                }}
                            >
                                <option value=''>Milage (max)</option>
                                {milageVal.map((value, i) => {
                                    return (<option key={i} value={value}>{value} Km</option>)
                                })}
                            </select>
                            <p>Price</p>
                            <select
                                name='minPrice'
                                onChange={event => {
                                    this.setState({
                                        minPrice: event.target.value
                                    })
                                }}
                            >
                                <option value=''>Price (min)</option>
                                {priceVal.map((value, i) => {
                                    return (<option key={i} value={value}>RM {value}</option>)
                                })}
                            </select>
                            <select
                                name='maxPrice'
                                onChange={event => {
                                    this.setState({
                                        maxPrice: event.target.value
                                    })
                                }}
                            >
                                <option value=''>Price (max)</option>
                                {priceVal.map((value, i) => {
                                    return (<option key={i} value={value}>RM {value}</option>)
                                })}
                            </select>
                            <p>Location</p>
                            <select
                                name='state'
                                onChange={event => {
                                    this.setState({
                                        state: event.target.value
                                    })
                                }}>
                                <option value=''>State</option>
                                {STATES.map(state => {
                                    return (<option key={state} value={state}>{state}</option>)
                                })}
                            </select>
                            <select >
                                <option value=''>Area </option>
                            </select>
                            <div className={classes.Controls}>
                                <button
                                    type='submit'
                                    className={classes.Btn}
                                >Show Results</button>
                                <button
                                    type='button'
                                    className={`${classes.Btn} ${classes.Rest}`}
                                    onClick={event => { this.restFormHandler() }}
                                >Reset</button>
                            </div>
                        </form>
                    </div>
                    :
                    null}

            </div>
        );
    }
}
;

const mapStateToProps = state => {
    return {
        vihecleType: state.SearchP.vehicleType
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onChangeType: (type) => { dispatch(actionCreators.changeVehicleType(type)) },
        onGetVehicleItems: (type, url) => { dispatch(actionCreators.getVehicleItems(type, 1, null, url)) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchOptions);